module.exports = __webpack_public_path__ + "static/logo-97f427d42225dc9030a275bae3eeb07f.png";